import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TravelBookingFareExtraModel')
export default class TravelBookingFareExtraModel {
  @JsonProperty('baggage', String, true)
  public baggage:string = '';
  @JsonProperty('cancellation', String, true)
  public cancellation:string = '';
  @JsonProperty('hand_luggage', String, true)
  public handLuggage:string = '';
  @JsonProperty('rebooking', String, true)
  public rebooking:string = '';
}